/**
 * Audits Dashboard Service
 * Service for fetching audits statistics dashboard data
 */

import { apiClient } from './apiClient';

export interface AuditsDashboardData {
  season: {
    id: number;
    name: string;
    year: number;
  };
  kpis: {
    total_audits: number;
    completed_audits: number;
    completion_percentage: number;
    avg_duration_hours: number;
    total_surface: number;
    avg_kg_per_ha: number;
  };
  types_by_year: TypeByYear[];
  monthly_evolution: MonthlyEvolution[];
  auditors: AuditorStats[];
}

export interface TypeByYear {
  year: number;
  country: string;
  audit_type: string;
  count: number;
  surface: number;
}

export interface MonthlyEvolution {
  season_year: number;
  month: number;
  month_name: string;
  count: number;
}

export interface AuditorStats {
  auditor_id: number;
  auditor_name: string;
  audits_count: number;
  surface: number;
  avg_duration_hours: number;
  avg_kg_per_ha: number;
  last_audit_date: string | null;
  audits_growth: number;
  surface_growth: number;
  duration_growth: number;
  kg_per_ha_growth: number;
}

export const auditsDashboardService = {
  /**
   * Get audits dashboard data
   * @param seasonId - Season ID (required)
   */
  async getDashboardData(seasonId: number): Promise<AuditsDashboardData> {
    const response = await apiClient.get('/audits/audits-dashboard/', {
      params: { season_id: seasonId },
    });
    return response.data;
  },
};
